import { ResponsiveContainer, ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { TrendUp, TrendDown, Pulse } from "@phosphor-icons/react";

const MONTHS = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"];
const mLabel = (m) => `${MONTHS[parseInt(m.slice(5, 7), 10) - 1]} ${m.slice(2, 4)}`;
const levelColor = { success: "#00e676", warning: "#ffea00", info: "#0084ff" };

export default function FitnessTrendCard({ trend }) {
  if (!trend) return null;
  const data = trend.months.map((m) => ({ ...m, label: mLabel(m.month) }));
  const c = levelColor[trend.level];
  const Arrow = trend.hrv_delta_pct >= 0 ? TrendUp : TrendDown;
  return (
    <div className="glass-card p-5" data-testid="fitness-trend-card">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <Pulse size={18} weight="fill" style={{ color: c }} />
        <h3 className="text-sm font-semibold">Кардио-тренд · <span style={{ color: c }}>{trend.verdict}</span></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4" data-testid="fitness-trend-text">
        За последние {trend.period_months} мес: HRV <span className={`num font-semibold inline-flex items-center gap-0.5 ${trend.hrv_delta_pct >= 0 ? "text-[#00e676]" : "text-[#ff3b30]"}`}><Arrow size={12} />{trend.hrv_delta_pct > 0 ? "+" : ""}{trend.hrv_delta_pct}%</span>
        {trend.rhr_delta_pct != null && <>, пульс покоя <span className={`num font-semibold ${trend.rhr_delta_pct <= 0 ? "text-[#00e676]" : "text-[#ff3b30]"}`}>{trend.rhr_delta_pct > 0 ? "+" : ""}{trend.rhr_delta_pct}%</span></>}.
        Рост HRV и снижение пульса покоя — главные маркеры роста тренированности.
      </p>
      <ResponsiveContainer width="100%" height={220}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 10% 16%)" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} />
          <YAxis yAxisId="hrv" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} width={30} />
          <YAxis yAxisId="rhr" orientation="right" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} width={30} />
          <Tooltip contentStyle={{ background: "hsl(220 10% 12%)", border: "1px solid hsl(220 10% 22%)", borderRadius: 8, fontSize: 12 }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line yAxisId="hrv" type="monotone" dataKey="hrv" name="HRV, мс" stroke="#00e676" strokeWidth={2} dot />
          <Line yAxisId="rhr" type="monotone" dataKey="rhr" name="Пульс покоя" stroke="#ff3b30" strokeWidth={2} dot />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
